import type { Component } from 'solid-js';
import {
  MyAccountIcon,
  MyMarketConditionsIcon,
  MyRewardIcon,
  MyRiskIcon,
  MyW8BenIcon,
  MySettingIcon,
  MyFunctionIcon,
  MyAboutUsIcon,
} from '../icons';

const defaultIconClass = 'icon-s-XL icon-c-D';

/** 自定义 SVG 组件 */
type MenuItemSvg = {
  IconRender: Component<{ class?: string }>;
  text: string;
  path: string;
  /** 传给根节点（svg）的 class，可覆盖默认尺寸/颜色类 */
  iconName?: string;
  iconClass?: string;
};

export type MenuItem = MenuItemSvg;

export const MENU_LIST: MenuItem[] = [
  {
    IconRender: MyAccountIcon,
    text: '账户与安全',
    path: '/account-security',
  },
  {
    IconRender: MyMarketConditionsIcon,
    text: '我的行情',
    path: '/market-condition',
  },
  {
    IconRender: MyRewardIcon,
    text: '奖励中心',
    path: '/award',
  },
  {
    IconRender: MyRiskIcon,
    text: '风险测评',
    path: '/risk-assessment',
  },
  {
    IconRender: MyW8BenIcon,
    text: 'W-8BEN确认',
    /** App WebView 常带 `?platform=rn` 等；内嵌时 w8ben 模块会隐藏 H5 顶栏，路径仍为 `/w8ben` */
    path: '/w8ben',
  },
  {
    IconRender: MyFunctionIcon,
    text: '功能建议',
    path: '/feedback',
  },
  {
    IconRender: MyAboutUsIcon,
    text: '关于我们',
    path: '/about-us',
  },
  {
    IconRender: MySettingIcon,
    text: '设置',
    path: '/settings',
  },
];
